import { APP_VERSION } from '../index';

export type CapturedError = {
  message: string;
  code?: string;
  stack?: string;
  at: string;
  pageUrl: string;
  appVersion: string;
  userAgent: string;
  context?: Record<string, unknown>;
};

export function captureError(error: unknown, context?: Record<string, unknown>): CapturedError {
  let message = 'Unknown error';
  let code: string | undefined;
  let stack: string | undefined;

  if (error instanceof Error) {
    message = error.message;
    stack = error.stack;
    code = (error as any).code;
  } else if (typeof error === 'string') {
    message = error;
  }

  return {
    message,
    code,
    stack,
    at: new Date().toISOString(),
    pageUrl: window.location.href,
    appVersion: APP_VERSION,
    userAgent: navigator.userAgent,
    context,
  };
}

export function formatErrorReport(captured: CapturedError, userNote?: string): string {
  const lines = [
    `Batchfather Error Report`,
    `========================`,
    `Time: ${captured.at}`,
    `Version: ${captured.appVersion}`,
    `Page: ${captured.pageUrl}`,
    ``,
    `Error: ${captured.message}`,
    ...(captured.code ? [`Code: ${captured.code}`] : []),
    ``,
    `Browser: ${captured.userAgent}`,
  ];

  if (captured.context && Object.keys(captured.context).length > 0) {
    lines.push(``, `Context:`, JSON.stringify(captured.context, null, 2));
  }

  if (captured.stack) {
    lines.push(``, `Stack:`, captured.stack);
  }

  const note = userNote?.trim();
  if (note) {
    lines.push(``, `User note:`, note);
  }

  return lines.join('\n');
}

export function buildMailtoUrl(captured: CapturedError, userNote?: string): string {
  const subject = `Batchfather Error Report v${captured.appVersion}`;
  const body = formatErrorReport(captured, userNote);
  // mailto body is URL-encoded, keep it reasonable for email clients
  const truncated = body.length > 1800 ? body.slice(0, 1800) + '\n...(truncated, use Copy for full report)' : body;
  return `mailto:info@batchfather.app?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(truncated)}`;
}
